var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('title-products',{attrs:{"title":"Produtos"}}),_c('view-products'),_c('open-edit-product'),_c('open-delete-product'),_c('open-add-product')],1)}
var staticRenderFns = []

export { render, staticRenderFns }